// URLs for the Related badges on the Pricetool Listings and Inventory grids.
// Every badge opens the All tab with both grids filtered and sorted the same
// way; only the product and inventory sets differ.

const PRICETOOL_PATH = "/datatables/pricetool";

// product_id and inventory_id are positive auto-increments, so this matches
// nothing. An empty isAnyOf is dropped by both the grid and the server, which
// would show every row instead of none.
const NO_MATCH_ID = -1;

export interface RelatedLinkSets {
  // Listings panel: these products' listings, without merchant rows
  productIds: number[];
  // Inventory panel: these parts
  inventoryIds: number[];
}

export const buildRelatedUrl = ({
  productIds,
  inventoryIds,
}: RelatedLinkSets): string => {
  const params = new URLSearchParams();
  params.set("tab", "all");
  // Carry the current column set into the new tab, like the toolbar's Open actions
  const colset = new URLSearchParams(window.location.search).get("colset");
  if (colset) params.set("colset", colset);

  // Sort params are read back in insertion order, so their order here is the
  // sort priority in the new tab.
  params.set("listings_filter_product.product_id_operator", "isAnyOf");
  params.set(
    "listings_filter_product.product_id_value",
    JSON.stringify(productIds.length ? productIds : [NO_MATCH_ID])
  );
  // Status is Amazon's status plus M (merchant) or F (FBA), so this drops
  // merchant offers. Competitor, Walmart and Shopify rows have no status and
  // are kept. The lambdas count badges with the same predicate.
  params.set(
    "listings_filter_amazon_listings.status_operator",
    "doesNotContain"
  );
  params.set("listings_filter_amazon_listings.status_value", "m");
  params.set("listings_sort_product.product_id", "asc");
  params.set("listings_sort_amazon_listings.sort", "asc");

  // Supply Inventory ID is a string column in the grid, so values are strings
  params.set("inventory_filter_supply.inventory_id_operator", "isAnyOf");
  params.set(
    "inventory_filter_supply.inventory_id_value",
    JSON.stringify(
      (inventoryIds.length ? inventoryIds : [NO_MATCH_ID]).map(String)
    )
  );
  params.set("inventory_sort_supply.inventory_id", "asc");
  params.set("inventory_sort_supply.sort", "asc");

  return `${PRICETOOL_PATH}?${params.toString()}`;
};

export const pluralizeAsins = (count: number) =>
  `${count} ASIN${count === 1 ? "" : "s"}`;
